import { useEffect, useState } from "react";
import type { Libraries } from "@react-google-maps/api";
import { useLoadScript } from "@react-google-maps/api";
import { isProdHostname } from "./isProd";

const DEV_API_KEY = "AIzaSyAk3KUUBOiiV-MgYaLg0bLBW1LuYT9uIB0";
const PROD_API_KEY = "AIzaSyDCw-dXbHWyeN28B1kNy4jyHvy-LTiBMuU";

const isProd = isProdHostname();
export const MAPS_API_KEY = isProd ? PROD_API_KEY : DEV_API_KEY;
export const MAPS_LIBRARIES: Libraries = ["places"];

export const useGooglePlaceDetails = (placeId: string | undefined) => {
  const [placeDetails, setPlaceDetails] = useState<google.maps.places.PlaceResult | null>(null);
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: MAPS_API_KEY,
    libraries: MAPS_LIBRARIES,
  });

  useEffect(() => {
    if (isLoaded && placeId && !placeDetails) {
      const service = new google.maps.places.PlacesService(document.createElement("div"));
      service.getDetails({ placeId }, (place, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK && place?.name) {
          setPlaceDetails(place);
        }
      });
    }
  }, [isLoaded, placeId]);
  return {
    place: placeDetails?.geometry ? { name: placeDetails.name, location: placeDetails.geometry.location } : null,
  };
};

export const useGooglePlaceName = (placeId: string | undefined) => {
  const { place } = useGooglePlaceDetails(placeId);
  const [placeName, setPlaceName] = useState<string>("");

  useEffect(() => {
    if (place?.name) {
      setPlaceName(place.name);
    }
  }, [place?.name]);
  return { placeName, setPlaceName };
};
